import React, { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { useAppTranslations } from '../../../../utils/hooks/useAppTranslations'
import RedirectUrlUtmGeneratorDialog from './RedirectUrlUtmGeneratorDialog'

interface RedirectUrlUtmGeneratorProps {
  redirectUrl: string
  disabled?: boolean
  onApply: (generatedUrl: string) => void
}

const RedirectUrlUtmGenerator: React.FC<RedirectUrlUtmGeneratorProps> = ({
  redirectUrl,
  disabled = false,
  onApply,
}) => {
  const t = useAppTranslations()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <Tooltip title={t('adgroup.redirectUrlUtmGenerator.generateUrl')}>
        <span>
          <IconButton
            color="primary"
            onClick={() => setIsDialogOpen(true)}
            disabled={disabled}
            aria-label={t('adgroup.redirectUrlUtmGenerator.generateUrl')}
            sx={(theme) => ({
              mt: theme.spacing(1),
              p: theme.spacing(1),
              minWidth: theme.spacing(4.5),
              minHeight: theme.spacing(4.5),
            })}
          >
            <AutoFixHighIcon />
          </IconButton>
        </span>
      </Tooltip>

      <RedirectUrlUtmGeneratorDialog
        open={isDialogOpen}
        setOpen={setIsDialogOpen}
        redirectUrl={redirectUrl}
        onApply={onApply}
      />
    </>
  )
}

export default RedirectUrlUtmGenerator
